import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './TermsAndConditions.css';

function TermsAndConditions() {
  return (
    <div className="terms-and-conditions-page">
      <Header />
      <div className="terms-and-conditions-content">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last Updated: March 6, 2026</p>

        <h2>1. Overview</h2>
        <p>Black Canyon Tickets ("Company," "we," "us," or "our") provides an online ticketing platform that allows event organizers to sell and distribute tickets to their events. Black Canyon Tickets acts solely as a ticketing service provider and is not the organizer, promoter, or operator of the events listed on our platform.</p>
        <p>By purchasing tickets through our website (blackcanyontickets.com) or affiliated platforms, you agree to these Terms and Conditions.</p>

        <h2>2. Role of Black Canyon Tickets</h2>
        <p>Black Canyon Tickets provides ticketing technology and payment processing services for event organizers. Black Canyon Tickets:</p>
        <ul>
          <li>Does not organize, produce, or host events</li>
          <li>Does not control event content, scheduling, or safety</li>
          <li>Does not determine event policies such as refunds, entry requirements, or seating</li>
        </ul>
        <p>The event organizer is solely responsible for the event and all matters related to it.</p>

        <h2>3. Ticket Purchases</h2>
        <p>When you purchase a ticket through Black Canyon Tickets:</p>
        <ul>
          <li>You are purchasing a ticket from the event organizer</li>
          <li>Black Canyon Tickets acts as a service provider and payment processor</li>
          <li>All ticket sales are subject to the policies set by the event organizer</li>
        </ul>
        <p>Prices, availability, and ticket limits are determined by the event organizer.</p>

        <h2>4. Refunds and Cancellations</h2>
        <p>Refund policies are determined by the event organizer, not Black Canyon Tickets. Unless otherwise stated:</p>
        <ul>
          <li>All ticket sales are final and non-refundable</li>
          <li>If an event is canceled, postponed, or rescheduled, the event organizer is responsible for determining refund policies</li>
        </ul>
        <p>Black Canyon Tickets may assist with processing refunds when directed by the event organizer, but we are not responsible for issuing refunds independently.</p>

        <h2>5. Event Changes</h2>
        <p>Events may be canceled, postponed, rescheduled, or modified at the discretion of the event organizer. Black Canyon Tickets is not responsible for changes to event dates, performers, schedules, or venues.</p>

        <h2>6. Ticket Delivery</h2>
        <p>Tickets may be delivered in one or more of the following ways:</p>
        <ul>
          <li>Digital tickets</li>
          <li>Mobile tickets</li>
          <li>Printable tickets</li>
          <li>On-site pickup</li>
        </ul>
        <p>Customers are responsible for ensuring that their contact information is correct at the time of purchase.</p>

        <h2>7. Resale and Transfer</h2>
        <p>Tickets may not be resold or transferred unless permitted by the event organizer. Black Canyon Tickets reserves the right to invalidate tickets that are resold in violation of event policies.</p>

        <h2>8. Fees</h2>
        <p>Service fees and processing fees may be added to ticket purchases. These fees support the operation of the ticketing platform and are generally non-refundable, unless required by law.</p>

        <h2>9. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, Black Canyon Tickets shall not be liable for:</p>
        <ul>
          <li>Event cancellations or postponements</li>
          <li>Changes in performers or schedules</li>
          <li>Venue issues</li>
          <li>Personal injury or property damage occurring at events</li>
        </ul>
        <p>Any disputes regarding the event itself must be directed to the event organizer.</p>

        <h2>10. Fraud and Chargebacks</h2>
        <p>Customers agree not to initiate fraudulent chargebacks for legitimate ticket purchases. If a chargeback occurs, Black Canyon Tickets reserves the right to cancel associated tickets, refuse future service, and pursue recovery of associated costs.</p>

        <h2>11. Website Use</h2>
        <p>Users agree not to attempt to interfere with the ticketing platform, use automated purchasing tools or bots, or misrepresent identity or payment information. Violations may result in account suspension.</p>

        <h2>12. Governing Law</h2>
        <p>These Terms shall be governed by the laws of the State of Colorado, without regard to conflict of law principles.</p>

        <h2>13. Contact Information</h2>
        <p>Black Canyon Tickets<br />
        Website: <a href="https://www.blackcanyontickets.com">blackcanyontickets.com</a><br />
        Email: <a href="mailto:support@blackcanyontickets.com">support@blackcanyontickets.com</a></p>
      </div>
      <Footer />
    </div>
  );
}

export default TermsAndConditions;